import React, { FC, useEffect, useState } from 'react'
import { Button, Input, Form, Select, Radio, message, Space } from 'antd'
import { FormProps } from 'antd/lib/form'
import { Card, Page, BackButton, DisplayInput } from '@comps'
import { Http, Context, Api } from '@utils'

const Item = Form.Item

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
};

const validateMessages = {
    // eslint-disable-next-line
    required: '请输入 ${label}',
    types: {
        email: '请输入正确的邮箱',
    }

};

interface State {
    id: any,
    loading: boolean,
    userName: string,
}

interface Props extends FormProps {
    history: any,
    match: any,
}

const Edit: FC = (props: any) => {
    const id = props.match.params.id
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [roleOptions, setRoleOptions] = useState<[]>([])

    useEffect(() => {
        Api.getKv('/sys/roles/kv').then((data: any) => {
            setRoleOptions(data)
        })

        Http.get(`/sys/users/${id}`).then((data: any) => {
            form?.setFieldsValue({ ...data })
        })
    },
        // eslint-disable-next-line
        [id])

    const toggle = () => {
        setLoading(!loading);
    };

    const handOnSave = () => {
        form.validateFields().then(values => {
            toggle()
            Http.put('/sys/users', { ...values, id: id }).then(data => {
                message.info('保存成功')
                Context.route('/sys/users')
            }).finally(() => {
                toggle()
            })
        })
    }

    return (
        <Page>
            <Card title='编辑用户' loading={loading}>
                <Form {...layout} name="form-user-edit" form={form}
                    initialValues={{ status: 'ACTIVE' }}
                    validateMessages={validateMessages}>
                    <Item label="用户名" name='userName'>
                        <DisplayInput />
                    </Item>
                    <Item label="工号" name='employeeNo'>
                        <DisplayInput />
                    </Item>
                    <Item name='lastName' label='姓名'><Input /></Item>
                    <Item name='emailAddress' label='邮箱' rules={[{ type: 'email' }]}><Input /></Item>
                    <Item name='mobile' label='手机号'><Input /></Item>
                    <Item name='gender' label='性别'>
                        <Radio.Group >
                            <Radio value='M'>男</Radio>
                            <Radio value='W'>女</Radio>
                        </Radio.Group>
                    </Item>
                    <Item name='status' label='状态'>
                        <Radio.Group>
                            <Radio value='ACTIVE'>有效</Radio>
                            <Radio value='INACTIVE'>已失效</Radio>
                            <Radio value='FROZEN'>冻结</Radio>
                        </Radio.Group>
                    </Item>
                    <Item name='roleIds' label='角色'>
                        <Select showSearch mode="multiple" options={roleOptions} />
                    </Item>
                    <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                        <Space>
                            <Button type="primary" onClick={handOnSave}>保存</Button>
                            <BackButton />
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </Page>
    )
}

export default Edit;